import { Drawer as BaseDrawer } from '@base-ui/react/drawer'

import { cn } from '@gto/ui/cn'

import type { DrawerLayer } from './layer'

type BackdropProps = BaseDrawer.Backdrop.Props & {
  /** Stacking band — must match the sibling `Drawer.Popup`'s. See its `layer`. */
  layer?: DrawerLayer
}

const LAYER_CLASS: Record<DrawerLayer, string> = {
  drawer: 'z-drawer',
  modal: 'z-modal',
  popover: 'z-popover',
}

export const Backdrop = ({ className, layer = 'drawer', ...props }: BackdropProps) => {
  return (
    <BaseDrawer.Backdrop
      forceRender
      className={cn(
        'fixed inset-0 bg-black/50',
        LAYER_CLASS[layer],
        'transition-opacity duration-300 ease-out',
        'data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
        className,
      )}
      {...props}
    />
  )
}
